<div class="technician-timer-wrapper" [ngClass]="{'isExpanded': isExpanded, 'bottom-pinch': showAtBottom}"
  [hidden]="!service?._id || isHideToolbar">
  <div class="technician-timer" (click)="toggleExpand()">
    <div class="progress-bar flex-start-start"
      [ngClass]="{'green': timeAllocatedMin > timeSpentMin, 'red': timeAllocatedMin < timeSpentMin}">
      <div class="flex-start-start green" [ngStyle]="{'width': greenProgressbarLength + '%' }"></div>
    </div>

    <div class="flex-center-center expand-icon">
      <i class="flex-center-center fas font-gray-55"
        [ngClass]="{'fa-chevron-down': isExpanded, 'fa-chevron-up': !isExpanded}"></i>
    </div>

    <div class="p-2" [ngClass]="{'flex-between-center': !isExpanded, 'flex-column': isExpanded}">
      <div class="flex-column left" *ngIf="!isExpanded"
        [ngClass]="{'play-mode': service?.timesheet?.action === 'inprogress'}">
        <div class="service-title text-truncate m-0 font-bold">
          {{helperService.getLocalizationValue(currentLang, service, 'title')}}
        </div>
        <p class="m-0 font-secondary-700 font-18 font-600">{{timeSpent}} / {{timeAllocated}}</p>
      </div>

      <div class="flex-end-center right" *ngIf="!isExpanded"
        [ngClass]="{'play-mode': service?.timesheet?.action === 'inprogress'}">
        <div class="flex-start-center" *ngIf="isStatusUpdating">
          <i class="fal fa-spinner rotate  font-21"></i>
        </div>

        <div class="play-button-wrapper flex-center-center"
          *ngIf="!isStatusUpdating && service?.timesheet?.action !== 'inprogress'"
          (click)="serviceAction(false, $event)">
          <i class="fas fa-play play-button"></i>
        </div>

        <div class="pause-button-wrapper flex-center-center mr-2"
          *ngIf="!isStatusUpdating && service?.timesheet?.action === 'inprogress'"
          (click)="serviceAction(false, $event)">
          <i class="fas fa-pause pause-button"></i>
        </div>

        <div class="pause-button-wrapper flex-center-center"
          *ngIf="!isStatusUpdating && service?.timesheet?.action === 'inprogress'"
          (click)="markComplete(false, $event)">
          <i class="fas fa-stop stop-button"></i>
        </div>
      </div>

      <div class="expanded-header flex-column width-100p" *ngIf="isExpanded"
        [ngClass]="{'play-mode': service?.timesheet?.action === 'inprogress'}">
        <div class="font-21 service-title text-truncate m-0 font-bold">
          {{helperService.getLocalizationValue(currentLang, service, 'title')}}
        </div>

        <div class="flex-between-center">
          <div class="flex-column flex-center-start">
            <p class="m-0 font-18 flex-start-center">
              <i class="fal fa-stopwatch pr-2"></i>
              <span>{{'tech-app.elapsed-time' | translate}}: {{timeSpent}}</span>
            </p>

            <p class="m-0 font-18 flex-start-center">
              <i class="fal fa-calendar-day pr-2"></i>
              <span>{{'tech-app.alloted-time' | translate}}: {{timeAllocated}}</span>
            </p>
          </div>

          <div class="flex-end-center">
            <div class="flex-start-center" *ngIf="isStatusUpdating">
              <i class="fal fa-spinner rotate  font-21"></i>
            </div>

            <div class="play-button-wrapper flex-center-center"
              *ngIf="!isStatusUpdating && service?.timesheet?.action !== 'inprogress'"
              (click)="serviceAction(false, $event)">
              <i class="fas fa-play play-button"></i>
            </div>

            <div class="pause-button-wrapper flex-center-center mr-2"
              *ngIf="!isStatusUpdating && service?.timesheet?.action === 'inprogress'"
              (click)="serviceAction(false, $event)">
              <i class="fas fa-pause pause-button"></i>
            </div>

            <div class="pause-button-wrapper flex-center-center"
              *ngIf="!isStatusUpdating && service?.timesheet?.action === 'inprogress'"
              (click)="markComplete(false, $event)">
              <i class="fas fa-stop stop-button"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="expanded-body" *ngIf="isExpanded">
        <div class="log-table flex-column width-100p">
          <div class="log-table-header flex-start-center width-100p">
            <p class="m-0 font-600 font-secondary-700 tech">{{'tech-app.tech' | translate}}</p>
            <p class="m-0 font-600 font-secondary-700 start">{{'tech-app.start' | translate}}</p>
            <p class="m-0 font-600 font-secondary-700 end">{{'tech-app.end' | translate}}</p>
          </div>

          <div class="log-table-body flex-column width-100p">
            <div class="log-table-row flex-start-center width-100p" *ngFor="let log of timeLogs">
              <p class="m-0 font-secondary-700 tech text-truncate"
                [ngClass]="{'font-600': log?.isInProgress,'tech-text':log?.tech.length >= 15}">{{log?.tech}}</p>
              <p class="m-0 font-secondary-700 start" [ngClass]="{'font-600': log?.isInProgress}">{{log?.startTz}}</p>
              <p class="m-0 font-secondary-700 end" [ngClass]="{'font-600': log?.isInProgress}">{{getTranslatedText(log?.endTz)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>